import {$, w} from './constants';
gsap.registerPlugin(ScrollTrigger, Draggable);

$(document).ready(function () {
    if( $('#home__market-marquee').length){
        cargarMarquee();
    }
});

function cargarMarquee(){
    $.ajax({
        type: 'POST',
        dataType: 'html',
        url: cltvo_js_vars.ajax_url,
        data: {
            action: 'marquee'
        },
        success: function(response) {
            $('#home__market-marquee').html(response);
            requestAnimationFrame(() => {
                initMarqueeEffects();
            });
        },
        error: function(xhr) {
            console.error('Error al cargar eventos:', xhr);
        }
    });
}

let marqueeTween = null;
let draggableInstance = null;

export function initMarqueeEffects() {
	const $marquee = document.querySelector('#home__market-marquee');
	const $marqueeInner = $marquee?.querySelector('.home__market-marquee-inner');
	if (!$marquee || !$marqueeInner) return;

	if (marqueeTween) marqueeTween.kill();
	if (draggableInstance?.kill) draggableInstance.kill();

	// 1. Crear placeholder
	const placeholder = document.querySelector('.marquee-placeholder') || document.createElement('div');
	placeholder.classList.add('marquee-placeholder');
	placeholder.style.height = $marquee.offsetHeight + 'px';
	if (!placeholder.parentNode) $marquee.parentNode.insertBefore(placeholder, $marquee.nextSibling);

	// 2. Duplicar contenido varias veces para efecto loop
	const originalContent = $marqueeInner.innerHTML;
	$marqueeInner.innerHTML = originalContent + originalContent + originalContent;

	// 3. Calcular scroll total
	const totalWidth = $marqueeInner.scrollWidth / 3;

	// 4. Iniciar animación
	marqueeTween = gsap.to($marqueeInner, {
		x: -totalWidth,
		duration: 40,
		ease: 'none',
		repeat: -1,
		modifiers: {
			x: gsap.utils.unitize(x => parseFloat(x) % totalWidth)
		}
	});

	// 5. Pausa en hover
	$marqueeInner.addEventListener('mouseenter', () => marqueeTween.pause());
	$marqueeInner.addEventListener('mouseleave', () => marqueeTween.resume());

	// 6. Draggable grab
	draggableInstance = Draggable.create($marqueeInner, {
		type: 'x',
		inertia: true,
		onPress() {
			marqueeTween.kill();
		},
		onRelease() {
			const currentX = gsap.getProperty($marqueeInner, 'x');
			marqueeTween = gsap.to($marqueeInner, {
				x: currentX - totalWidth,
				duration: 40,
				ease: 'none',
				repeat: -1,
				modifiers: {
					x: gsap.utils.unitize(x => parseFloat(x) % totalWidth)
				}
			});
		}
	})[0];
}

function updateHeaderHeightVar() {
	const header = document.querySelector('header');
	if (!header) return;

	const height = header.offsetHeight;
	document.documentElement.style.setProperty('--header-height', `${height}px`);
}

window.addEventListener('load', updateHeaderHeightVar);
window.addEventListener('resize', () => {
	requestAnimationFrame(updateHeaderHeightVar);
});